'use strict';
import React, { useEffect, useState } from 'react';
import { getVideo } from '../../service/theme';
import { userStore, videoStore } from '../../store';
import Header from '../common/Header';
import { useNavigate } from "react-router-dom";
import styles from './assets/index.module.scss';
import useUrlSearch from '../../utils/useUrlSearch';
import { ProgressBar, Tag } from 'antd-mobile'
import Emptyer from '../../utils/Emptyer';
import Loading from '../../utils/Loading';

export default function DDS_lanhupage_0() {

  const { userId, page, pageSize } = userStore;

  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);

  const [video, setVideo] = useState({
    title: '',
    list: []
  })

  const { getByKey } = useUrlSearch()

  useEffect(() => {
    let knowledgeId = getByKey('knowledgeId')
    let knowledgeTitle = getByKey('knowledgeName')
    async function GetVideo() {
      const res = await getVideo({ userId, page, pageSize, knowledgeId })
      // console.log('知识点下视频列表', res.data.rows)
      if (res.status) {
        setVideo({
          list: res.data.rows,
          title: knowledgeTitle
        })
        setLoading(false)
        videoStore.videos = res.data.rows
        localStorage.setItem('videoCache', JSON.stringify(res.data.rows))
      }
    }
    GetVideo()
  }, [])

  const learn = (v) => {
    navigate(`/lanhu_4?id=${v.videoId}`)
  }

  return (
    <div className={`${styles.page} flex-col`}>
      <div className={`${styles.bd1} flex-col`}>
        <div className={`${styles.mod1} flex-col`}>
          {/* <Header className={`${styles.group1} flex-col`} /> */}
          <span className={`${styles.txt1}`}>{video.title}</span>
          <div className={`${styles.group2} flex-col`}>
            <div className={`${styles.mod2} flex-col justify-between`}>

              {
                loading ? <Loading /> :
                  video.list.length > 0 ? video.list.map((v, i) => (
                    <div key={v.videoId + i} onClick={() => learn(v)}>
                      <div className={`${styles.bd2} flex-row justify-between`}>
                        <div className={`${styles.bd3} flex-col`}>
                          <img
                            className={`${styles.pic1}`}
                            src={v.videoImgUrl?.replace('http://192.169.250.225:8888', 'https://onlinetest.shasteel.cn')}
                          />
                        </div>
                        <div className={`${styles.bd4} flex-col`}>
                          <span className={`${styles.txt2}`}>{v.videoTitle}</span>
                          <span className={`${styles.info1}`}>{v.videoSubtitle ?? '没有简介'}</span>
                          <div className={`${styles.txt3}`}>
                            {
                              v.record !== '0' ?
                                (v.record === '100' ? <Tag color='success'>已看完</Tag> :
                                  <div className={`${styles.prg}`}><ProgressBar style={{ width: 70, marginLeft: 2, marginRight: 10, '--track-width': '5px', }} percent={v.record} /><span>已看{Math.floor(v.record * 100) / 100}%</span></div>)
                                :
                                <Tag color='warning' >暂无观看记录</Tag>
                            }
                          </div>
                        </div>
                      </div>
                      {
                        i < video.list.length - 1 &&
                        <img
                          className={`${styles.pic2}`}
                          src={
                            require('./assets/img/SketchPng2a2b39252316f295592dca01fb91c06dee0a6cf9636c62befc29878553cfb646.png')
                          }
                        />
                      }
                    </div>
                  )) : <Emptyer desc='暂无视频' />
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
